import { addRxStorageMultiInstanceSupport as t, getPrimaryFieldOfPrimaryKey as e, getStartIndexStringFromLowerBound as n, getStartIndexStringFromUpperBound as s, now as a, promiseWait as i } from "rxdb/plugins/core";
import { Subject as r } from "rxjs";
import { attachmentObjectId as o, closeIndexedDBDatabase as c, ensureNotClosed as h, getIndexedDBState as m, runReadTask as d, getStoreNamesForStorageInstance as u, RX_STORAGE_NAME_INDEXEDDB as l, createTx as w } from "./indexeddb-helpers.js";
import { getIndexableStringByIndexName as y, getIndexId as p } from "./indexeddb-index-helpers.js";
import { countIndexedDB as x, queryIndexedDB as g } from "./indexeddb-query.js";
import { indexedDBFindByIds as b } from "./indexeddb-find-by-ids.js";
import { bulkWrite as f } from "./indexeddb-bulk-write.js";
import { CLEANUP_INDEX as v } from "../shared/index-helpers.js";
var I = a();
export var RxStorageInstanceIndexedDB = function () {
  function t(t, n, s, a, i, o, c) {
    this.changes$ = new r(), this.instanceId = I++, this.storage = t, this.databaseName = n, this.collectionName = s, this.schema = a, this.internals = i, this.options = o, this.settings = c, this.primaryPath = e(this.schema.primaryKey);
  }
  var m = t.prototype;
  return m.updateMinKnownDocs = function (t) {
    this.internals.minKnownDocsAmount < t && (this.internals.minKnownDocsAmount = t);
  }, m.bulkWrite = async function (t, e) {
    var n = await f(this, t, e);
    return this.updateMinKnownDocs(t.length - n.error.length), n;
  }, m.findDocumentsById = async function (t, e) {
    h(this);
    var n = await d(this, async n => {
      var s = n.objectStore(this.internals.storeNames.documentStore);
      return b(s, t, e);
    });
    return this.updateMinKnownDocs(n.length), n;
  }, m.query = async function (t) {
    await this.internals.state.creationPromise, h(this);
    var e = await g(this, t);
    return this.updateMinKnownDocs(e.documents.length), e;
  }, m.count = async function (t) {
    if (t.queryPlan.selectorSatisfiedByIndex) {
      var e = await x(this, t);
      return this.updateMinKnownDocs(e.count), e;
    }
    var n = await g(this, t);
    return this.updateMinKnownDocs(n.documents.length), {
      count: n.documents.length,
      mode: "slow"
    };
  }, m.changeStream = function () {
    return this.changes$.asObservable();
  }, m.cleanup = async function (t) {
    await i(0), await i(0);
    var e = this.internals.state;
    await e.creationPromise;
    var r = this.settings.IDBKeyRange;
    h(this);
    var o = (await w(this)).objectStore(this.internals.storeNames.documentStore),
      c = this.settings.batchSize,
      m = a() - t,
      d = p(this.internals, v),
      u = o.index(d),
      l = n(this.schema, v, [!0, 1]),
      y = s(this.schema, v, [!0, m]),
      x = r.bound(l, y, !0, !0),
      g = await new Promise((t, e) => {
        var n = u.getAll(x, c);
        n.onerror = e, n.onsuccess = function (e) {
          t(e.target.result);
        };
      });
    return await Promise.all(g.map(t => new Promise((e, n) => {
      var s = t.i,
        a = o.delete(s);
      a.onerror = n, a.onsuccess = () => e();
    }))), g.length < c;
  }, m.remove = async function () {
    var t = this.internals.state;
    return await t.creationPromise, h(this), d(this, async t => {
      var e = [t.objectStore(this.internals.storeNames.documentStore), t.objectStore(this.internals.storeNames.writeAheadStore)];
      return this.schema.attachments && e.push(t.objectStore(this.internals.storeNames.attachmentsStore)), await Promise.all(e.map(t => new Promise((e, n) => {
        var s = t.clear();
        s.onerror = n, s.onsuccess = e;
      }))), this.close();
    });
  }, m.getAttachmentData = async function (t, e) {
    var n = this.internals.state;
    return await n.creationPromise, h(this), d(this, n => {
      var s = n.objectStore(this.internals.storeNames.attachmentsStore),
        a = o(t, e);
      return new Promise((n, i) => {
        var r = s.get(a);
        r.onsuccess = () => {
          var s = r.result;
          s ? n(s.data) : i("attachment missing documentId: " + t + " attachmentId: " + e);
        };
      });
    });
  }, m.close = async function () {
    return this.closed || (this.closed = (async () => (await this.internals.state.creationPromise, await d(this, async t => {}), this.changes$.complete(), c(this.internals.state)))()), this.closed;
  }, t;
}();
export async function createIndexedDBStorageInstance(e, n, s) {
  var a = y(n.schema),
    i = Array.from(a.indexIdByName.values()),
    r = await m(e, s, n, [{
      collectionName: n.collectionName,
      schema: n.schema,
      indexIds: i
    }]);
  await r.creationPromise;
  var o = {
      state: r,
      storeNames: u(n.collectionName, n.schema),
      getIndexableStringByIndexId: a.monadByIndexId,
      getIndexableStringByIndexNumber: Object.values(a.monadByIndexId),
      indexIdByName: a.indexIdByName,
      indexNames: Object.keys(a),
      indexIds: i,
      minKnownDocsAmount: 0
    },
    c = new RxStorageInstanceIndexedDB(e, n.databaseName, n.collectionName, n.schema, o, n.options, s);
  return await t(l, n, c), c;
}